import React, { useRef, useState, useImperativeHandle, useEffect } from "react";
import ModalView from '@/components/modal-view'
import styled from "styled-components";
import ModalBG from '../imgs/common-modal-bg@2x.png';
import UploadTitle from '../imgs/upload-title@2x.png';
import UploadConfirm from '../imgs/upload-confirm@2x.png';

import { rsaString } from '@/utils'
import { Toast} from 'antd-mobile';
import { sendMessage, loginWithCode } from '@/api/user-new'

const regPhone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;

const UploadModal = React.forwardRef(({ success }, ref) => {
  const [showModal, setShowModal] = useState(false);

  const countDownRef = useRef(59);

  const phoneRef = useRef('');
  const validcodeRef = useRef('');

  const countDownTimer = useRef(null);

  const sendBtn = useRef();
  const countDownBtn = useRef();
  const controlRef = useRef();

  useEffect(() => {
    sendBtn.current = document.createElement('div');
    sendBtn.current.className = 'validcode-btn';
    sendBtn.current.innerText = '获取验证码'
    sendBtn.current.addEventListener('click', () => handleSendCode());

    countDownBtn.current = document.createElement('div');
    countDownBtn.current.className = 'sending-text';
  }, []);

  useImperativeHandle(ref, () => {
    return {
      show: () => {
        setShowModal(true);
      },
      close: () => setShowModal(false),
    }
  });

  const startCountDown = () => {

    const child2 = controlRef.current ? controlRef.current.children[1] : null;
    if (child2) {
      controlRef.current.removeChild(child2);
    }
    controlRef.current.appendChild(countDownBtn.current);
    countDownBtn.current.innerText = '59秒后重新获取';
    countDownRef.current = 59;

    if (countDownTimer.current) {
      clearInterval(countDownTimer.current);
      countDownTimer.current = null;
    }

    countDownTimer.current = setInterval(() => {
      const countdownValue = countDownRef.current;
      if (countdownValue === 0) {

        clearInterval(countDownTimer.current);
        countDownTimer.current = null;


        controlRef.current.removeChild(controlRef.current.children[1]);
        controlRef.current.appendChild(sendBtn.current);
        return;
      }
      const nextValue = countdownValue - 1;

      countDownBtn.current.innerText = `${nextValue}秒后重新获取`;
      countDownRef.current = nextValue;

    }, 1000);
  }

  const handleSendCode = () => {
    const phone = phoneRef.current;
    if(!regPhone.test(phone)){
      Toast.info('请输入正确手机号');
    } else {
      sendMessage({ PHONE:rsaString(phone), type: '1'}).then(res=>{
        if(res.resultCode === '00'){
          startCountDown();
        } else {
          Toast.info(res.resultMsg)
        }
      });
    }
  }

  const handleUpload = () => {
    const phone = phoneRef.current;
    const validCode = validcodeRef.current
    if (!phone || !validCode) {
      Toast.info("请输入手机号和验证码");
      return;
    }

    loginWithCode({
      C_PHONE: rsaString(phone),
      C_SMS_CODE: rsaString(validCode),
      type: '1'
    }).then(res => {
      Toast.info("上传成功");
      setShowModal(false);
      success && success();
    })
  }

  return (
    <ModalView
      visible={showModal}
      onClose={() => setShowModal(false)}
      content={
        <ModalWrap>
          <div className="modal-content">
          <RankModalContent>
            <div className="flex-center">
              <img className="upload-title" alt="" src={UploadTitle} />
            </div>
            <div className="upload-row upload-row1">
              <span className="input-label">手机号</span>
              <div className="input-wrap">
                <input onChange={e => phoneRef.current = e.target.value} type="number" className="upload-input upload-input1"/>
              </div>
            </div>
            <div className="upload-row">
              <span className="input-label">验证码</span>
              <div className="input-wrap" ref={controlRef}>
                <div className="input-fixd">
                  <input className="upload-input" onChange={e => validcodeRef.current = e.target.value}/>
                </div>
                <div className="validcode-btn" onClick={handleSendCode}>获取验证码</div>
              </div>
            </div>
            <div className="flex-center upload-confirm">
              <img onClick={handleUpload} alt="" src={UploadConfirm} className="confirm-btn"/>
            </div>
          </RankModalContent>
          </div>
        </ModalWrap>
      }
    />
  )
})

const RankModalContent = styled.div`
  color: #000000;
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .upload-confirm {
    padding-bottom: 13px;
  }
  .upload-title {
    width: 148px;
    height: 23px;
    margin-bottom: 23px;
  }
  .upload-row1 {
    margin-bottom: 27px;
  }
  .upload-row {
    display: flex;
    padding: 0 30px;
    align-items: center;
    
    .input-wrap {
      overflow: hidden;
      display: flex;
      flex: 1;
      height: 39px;
      border: 2px solid #000000;
      border-radius: 5px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;
      align-items: center;
    }
    .input-label {
      font-size: 18px;
      font-weight: 400;
      line-height: 18px;
      margin-right: 12px;
      white-space: nowrap;
    }
   
    .upload-input {
      border: none;
      height: 30px;
      padding-left: 8px;
      width: 80px;
    }
    .upload-input1 {
      width: 120px;
    }
    .validcode-btn {
      position: absolute;
      right: -2px;
      top: -2px;
      width: 95px;
      height: 39px;
      background: #04596D;
      border: 2px solid #000000;
      border-radius: 5px;
      box-sizing: border-box;

      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 39px;
      text-align: center;
    }
    .sending-text {
      font-size: 14px;
      font-weight: 400;
      color: #A9A9A9;
      padding-right: 8px;
      flex-shrink: 0;
      text-align: right;
      flex: 1;
      white-space: nowrap;
    }
    .input-fixd {
      overflow: hidden;
    }
  }
  .confirm-btn {
    width: 172px;
    height: 46px;
    margin-top: 23px;
  }
`;

const ModalWrap = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 27px;
  color: #333;
  .modal-content {
    position: relative;
    border-radius: 10px;
    padding: 49px 0 17px;
    background-image: url(${ModalBG});
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
`

export default React.memo(UploadModal);




// WEBPACK FOOTER //
// ./src/views/activity_31/components/upload-modal.js